module.exports = __webpack_public_path__ + "img/0Q3A6453_L_Black_MockedUp.8c6142f6.jpg";